var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.846,
    height: 17.222,
    viewBox: "0 0 23.846 17.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.853 9.605H.994a.994.994 0 0 1 0-1.987h21.859a.994.994 0 0 1 0 1.987zm0 0",
    "data-name": "Trazado 1980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.853 1.987H.994A.994.994 0 0 1 .994 0h21.859a.994.994 0 0 1 0 1.987zm0 0",
    "data-name": "Trazado 1981"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.853 17.222H.994a.994.994 0 0 1 0-1.987h21.859a.994.994 0 0 1 0 1.987zm0 0",
    "data-name": "Trazado 1982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMenu);
export default __webpack_public_path__ + "static/media/open-menu.61b52525.svg";
export { ForwardRef as ReactComponent };